<template>
  <div class="pay_cont apayaccount target_apayaccount">
    <div class="row card-method">
      <div id="paymentPanel01">
        <div class="swiper mySwiper card-swiper type-gray">
          <div class="swiper-wrapper" v-if="haveAccount">

            <Flicking
              class="flicking-camera"
              :plugins="plugins"
              :options="swiperOptions"
              @changed="onSlideChange"
              @select="onSlideSelect"
              @ready="onSwiperReady"
            >
              <account-slider
                v-for="(account, index) in accounts"
                :key="index"
                :class="index === activeIndex ? 'swiper-slide-active' : ''"
                :account="account" />

              <span slot="viewport" class="swiper-button-prev"></span>
              <span slot="viewport" class="swiper-button-next"></span>
            </Flicking>
          </div>

          <div class="swiper-wrapper" v-else>

            <Flicking
              class="flicking-camera"
              :plugins="plugins"
              :options="swiperOptions"
            >
              <div class="swiper-slide" style="width: 302px !important; padding: 0 8px;">
                <div class="payment-unit">
                  <a class="payment-link">
                    <div
                      class="payment-card card-area">
                      <p>
                        등록된 A Pay 계좌/카드가 없습니다.<br>
                        암웨이 홈페이지에서 등록 후 사용해주세요.
                      </p>
                    </div>
                  </a>
                </div>
              </div>
              <span slot="viewport" class="swiper-button-prev"></span>
              <span slot="viewport" class="swiper-button-next"></span>
            </Flicking>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountSlider from "@/views/order/main/components/Payment/AccountSlider";
import { Flicking } from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";
import { Arrow } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/arrow.css";
import { log } from "@/utils/common";
import { mapGetters } from 'vuex';

export default {
  name: "AmwayPayAccount",
  components: {
    AccountSlider,
    Flicking
  },
  data() {
    return {
      plugins: [
        new Arrow({
          prevElSelector: '.swiper-button-prev',
          nextElSelector: '.swiper-button-next'
        }),
      ],
      activeIndex: 0,
      swiperOptions: {
        align: 'center',
        circular: false,
        panelsPerView: -1,
        noPanelStyleOverride: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      selectedParty: "amwaypay/selectedParty",
    }),
    accounts() {
      return this.selectedParty === 0 ? this.amwayPayAccounts.masterParty : this.amwayPayAccounts.subParty
    },
    haveAccount() {
      return this.accounts.length > 0;
    },
  },
  methods: {
    onSlideChange(data) {
      this.activeIndex = data.index;
      this.chooseAccount(this.activeIndex);
    },
    onSlideSelect(data) {
      this.activeIndex = data.index;
      data.panel.focus(300);
      this.chooseAccount(this.activeIndex);
    },
    onSwiperReady(event) {
      this.chooseAccount(event.currentTarget.currentPanel.index);
    },
    chooseAccount(index) {
      const selectedAccount = this.accounts[index];
      this.$store.commit('amwaypay/selectAmwayPayAccount', selectedAccount);
      log("ChooseAPayAccount:: ", selectedAccount);
    },
  },
  props: {
    amwayPayAccounts: {
      type: Object,
      required: true
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order/main/components/Payment/AmwayPayAccount.vue